<nz-input-group [nzSuffix]="suffixIconSearch">
  <input #searchInputBox  type="text" nz-input (input)="input$.next($event)" />
</nz-input-group>
<ng-template #suffixIconSearch>
  <i nz-icon nzType="search"></i>
</ng-template>